// import VideoJS from "@/components/VideoJS/VideoJS";
// import assest from "@/json/assest";
import assest from "../../../json/assest";
import { Dialog, DialogProps } from "@mui/material";
import React from "react";
import VideoJS from "../../VideoJS/VideoJS";

// type GalleryModalProps = DialogProps;
export default function GalleryModal(props) {
  return (
    <Dialog
      PaperProps={{
        className: "videoModal",
      }}
      {...props}
    >
      <VideoJS
        options={{
          autoplay: false,
          sources: [
            {
              src: assest.video,
            },
          ],
        }}
      />
    </Dialog>
  );
}
